<template>
  <the-navigation-layout
    title="Dashboard"
    :items="items"
    v-if="$can(ActionEnum.READ, ResourceEnum.ANALYTICS_ADMIN)"
  ></the-navigation-layout>
</template>

<script lang="ts">
import { IMenuListItem } from "@/lib/interfaces/menu-list-item.interface";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { AuthRolesEnum } from "@/store/enum/authRolesEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Vue } from "vue-property-decorator";
import TheNavigationLayout from "./TheNavigationLayout.vue";

@Component({ components: { TheNavigationLayout } })
export default class TheThgAnalyticsList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get isTradingScopeVisible(): boolean {
    const roles = UserModule.user.roles ?? [];
    return roles.includes(AuthRolesEnum.ADMIN) && roles.includes(AuthRolesEnum.THG_TRADER);
  }

  get items(): IMenuListItem[] {
    const items: IMenuListItem[] = [
      {
        icon: "mdi-chart-line",
        text: "navigation.TheThgAdminList.analytics",
        link: "/analytics",
        isEnabled: true
      }
    ];

    if (this.isTradingScopeVisible) {
      items.push({
        icon: "mdi-swap-horizontal",
        text: "views.thgPortal.TradingScopeListView.title",
        link: "/trading-scope",
        isEnabled: true
      });
    }

    return items;
  }
}
</script>

<style scoped></style>
